var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slider',_vm._b({staticClass:"vuestic-slider",attrs:{"value":_vm.value,"bg-style":_vm.sliderOptions.bgStyle,"slider-style":_vm.sliderOptions.sliderStyle,"reverse":_vm.reverse},on:{"input":_vm.change}},'slider',_vm.sliderOptions,false))}
var staticRenderFns = []

export { render, staticRenderFns }